// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"430":"400f33da","791":"350584b6"}[chunkId] + ".chunk.js";
};